import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { AttachmentModule } from '@sb/library/attachment';
import { ButtonModule } from '@sb/library/button';
import { IconModule } from '@sb/library/icon';
import { IframeModule } from '@sb/library/iframe';
import { LayoutModule } from '@sb/library/layout';
import { ProgressBarModule } from '@sb/library/progress-bar';
import { SubmissionBarModule } from '@sb/library/submission-bar';
import { UtilityModule } from '@sb/library/utility';
import { DialogConfirmComponent } from './confirm/dialog-confirm.component';
import { DialogDeleteComponent } from './delete/dialog-delete.component';
import { DialogIFrameComponent } from './iframe/dialog-iframe.component';
import { DialogInfoComponent } from './info/dialog-info.component';
import { DialogProgressComponent } from './progress/dialog-progress.component';
import { DialogWarningComponent } from './warning/dialog-warning.component';

@NgModule({
    declarations: [
        DialogProgressComponent,
        DialogConfirmComponent,
        DialogDeleteComponent,
        DialogInfoComponent,
        DialogWarningComponent,
        DialogIFrameComponent,
    ],
    imports: [
        CommonModule,
        ButtonModule,
        MatDialogModule,
        IconModule,
        MatDividerModule,
        AttachmentModule,
        LayoutModule,
        ProgressBarModule,
        UtilityModule,
        IframeModule,
        SubmissionBarModule
    ],
    exports: [
        DialogProgressComponent,
        DialogConfirmComponent,
        DialogDeleteComponent,
        DialogInfoComponent,
        DialogWarningComponent,
    ],
})
export class DialogModule {}
